<template>
	<article class="inactivated-list--page">
		<ListFilter />
		<ListContainer>
			<table class="table-main">
				<thead>
					<tr>
						<th>#</th>
						<th>회원번호</th>
						<th>닉네임</th>
						<th>이메일주소</th>
						<th v-if="hasAuthority">이름</th>
						<th v-if="hasAuthority">전화번호</th>
						<th>휴면전환일</th>
						<th>가입일시</th>
						<th>마지막 접속일시</th>
						<th>SNS연동</th>
						<th>성별</th>
						<th>나이</th>
						<th>피부타입</th>
						<th>단말기</th>
						<th>리뷰수</th>
						<th>당첨수</th>
						<th>이미지</th>
					</tr>
				</thead>
				<tbody>
					<tr
						v-for="item in getInactivatedList"
						:key="item.idRegister"
					>
						<td>{{ item.idx }}</td>
						<td>{{ item.idRegister }}</td>
						<td>
							<a
								class="inactivated-list__link"
								:href="item.infoLink"
							>
								{{ item.nickname }}
							</a>
						</td>
						<td>{{ item.email }}</td>
						<td v-if="hasAuthority">{{ item.userName }}</td>
						<td v-if="hasAuthority">{{ item.userTel }}</td>
						<td>{{ item.inactivatedDate }}</td>
						<td>{{ item.createDate }}</td>
						<td>{{ item.lastDate }}</td>
						<td>{{ item.sns }}</td>
						<td>{{ item.gender }}</td>
						<td>{{ item.age }}</td>
						<td>{{ item.skinType }}</td>
						<td>
							{{ item.fcmToken.os }} /
							{{ item.fcmToken.appVersion }}
						</td>
						<td>{{ item.reviewCount }}</td>
						<td>{{ item.winCount }}</td>
						<td>
							<i
								:class="[
									item.hasFileName
										? 'fa-check-circle'
										: 'fa-times-circle',
									'fa activated-list___file-save-name',
								]"
								aria-hidden="true"
							></i>
						</td>
					</tr>
				</tbody>
			</table>
		</ListContainer>
	</article>
</template>

<script>
	import { mapGetters } from 'vuex';
	import ListFilter from '@/components/register/ListFilter.vue';
	import ListContainer from '@/components/register/ListContainer.vue';

	export default {
		name: 'InactivatedList',
		components: { ListFilter, ListContainer },
		computed: {
			...mapGetters('register', ['getInactivatedList', 'hasAuthority']),
		},
		beforeCreate() {
			this.$store.commit('register/changeState', [
				{
					key: 'keyList',
					value: [
						'idRegister',
						'email',
						'skinType',
						'recommendNickname',
						'reviewCountRange',
						'userName',
						'sns',
						'nickname',
						'gender',
						'ageRange',
						'createDateRange',
						'winCountRange',
						'userTel',
						'isBlind',
						'inactivatedDateRange',
						'regionObj',
					],
				},
				{
					key: 'orderList',
					value: [
						{ id: 1, text: '최근휴면순' },
						{ id: 2, text: '이전휴면순' },
						{ id: 3, text: '최신등록순' },
						{ id: 4, text: '이전등록순' },
						{ id: 5, text: '이미지순' },
						{ id: 6, text: 'NO이미지순' },
						{ id: 7, text: '리뷰많은순' },
						{ id: 8, text: '리뷰적은순' },
						{ id: 9, text: '이벤트당첨순' },
						{ id: 10, text: '이벤트당첨역순' },
					],
				},
				{ key: 'pageType', value: 'inactivated' },
				{ key: 'order', value: 1 },
				{ key: 'orderDefault', value: 1 },
				{ key: 'limit', value: 10 },
			]);
		},
	};
</script>

<style lang="scss" scoped>
	.inactivated-list--page {
		.inactivated-list__link {
			color: $btn-blue;
			font-weight: 700;

			&:hover {
				text-decoration: underline;
			}
		}
	}
</style>
